import GameUtil from "../../../../../utility/game_util";
import SpriteFrameHolder from "../../../../public/ui/spriteFrameHolder";
import { TaskHelp } from "../task_help";

const {ccclass, property} = cc._decorator;

@ccclass
export class TaskGrowthItem extends cc.Component {

    @property(cc.Node)
    finishBtn:cc.Node = null;

    @property(cc.Node)
    awardBtn:cc.Node = null;

    @property(cc.Label)
    awardProgress:cc.Label = null;

    @property(cc.Label)
    awardnumb:cc.Label = null;

    @property(cc.Label)
    content:cc.Label = null;

    @property(SpriteFrameHolder)
    spriteHold:SpriteFrameHolder = null;

    @property(cc.Sprite)
    icon:cc.Sprite = null;

    @property(cc.ProgressBar)
    progress:cc.ProgressBar = null;

    @property(cc.ProgressBar)
    finishProgress:cc.ProgressBar = null;


    @property(cc.Sprite)
    finishSprite:cc.Sprite = null;

    @property(cc.Node)
    smallIcon:cc.Node[] = [];


    refreshItem(data:any,func?:Function){
        this.reset();
        this.finishBtn.on('click', function(){
            func && func(data);
        }, this)

        this.awardBtn.on('click', function(){
            func && func(data);
        }, this)

        this.updateIcon(data.conditionCode)
        this.updateAwardNumb(data.awardAccountVal);
        this.updateCnt(true,data.isFinish,Number(data.currentConditionVal),Number(data.conditionVal));
        this.updateTitle(data.taskContent);
        this.updateBtnState(data.isFinish,data.isReceive,data.conditionCode)
        this.updateProgress(data);
        this.updateSmallIcon(data.awardAccountType);
    }

    protected updateSmallIcon(type:number){
        let isDaiBi = (type == 100);
        this.smallIcon[0].active = !isDaiBi;
        this.smallIcon[1].active = isDaiBi;
    }

    protected updateProgress(data:any){
        let cur = data.currentConditionVal;//条件值
        let total = data.conditionVal;//当前值
        let percent = cur / total;
        if (total == 0) {
            percent = 0;            
        }
        this.progress.progress = percent > 1 ? 1:percent;
        this.finishProgress.progress = percent > 1 ? 1:percent;
    }

    
    protected updateIcon(conditionCode:string){
        let str = conditionCode.split('_');
        let iconName = 'SYS'
        if (str && str[0]) {
            iconName = str[0];
        }
        this.icon.spriteFrame = this.spriteHold.getSpriteFrameByKey(iconName);
    }

    protected updateCnt(isShow:boolean,isFinish?:boolean,cur?:number,total?:number){
        this.awardProgress.node.active = isShow;
        if (isShow) {
            if (cur > total) {
                cur = total;
            }
            let _cur = GameUtil.currencyFormatting(cur,2,true)
            let _total = GameUtil.currencyFormatting(total,2,true)
            this.awardProgress.string = '{0}/{1}'.format(_cur,_total);
            this.awardProgress.node.color = isFinish ? new cc.Color(24,161,0,255):new cc.Color(237,26,21,255);
        }
    }

    protected updateBtnState(isFinish:boolean,isReceive:boolean,code:string){
        let isCanReceive = isFinish && !isReceive;
        this.awardBtn.active = isCanReceive;//是否领取 false 没有领取
        this.finishBtn.active = !isFinish && !TaskHelp.isSysType(code);//需要去完成
        let finish =  (isFinish && isReceive);
        this.finishSprite.node.active = finish;
        this.progress.node.active = finish;
        this.finishProgress.node.active = !finish;
    }

    protected updateTitle(content:string){
        this.content.string = content;
    }

    protected updateAwardNumb(number:number){
        let cnt = GameUtil.currencyFormatting(number,2,true)
        this.awardnumb.string = cnt;
    }

    reset(){
        this.finishBtn.targetOff(this);
        this.awardBtn.targetOff(this);
    }
}
